import React from "react";

export default function Footer() {
//   let footerStyle = {
//     position: "relative",
//     width: "100%",
//     top: "100vh",
//   }

  return (
    <footer className=" text-light py-2"
            style={{ backgroundColor: "#004AAD" }}
            >

      
      <p className="text-center">Made with ❤️ & React.js by Yash Raj Mani</p>
    </footer>
  );
}
